<script>

/**
 * Nav-bar Component
 */
export default {
  components: {},
  props: {
    newspaper: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {};
  },
  methods: {
  }
};
</script>

<template>
  <b-card no-body class="text-center">
    <b-card-body>
      <b-img class="img-fluid" :src="`/api/newspapers/${newspaper.id}/image`"></b-img>

      <h5 class="font-size-15 mb-1">
        <span class="text-dark">{{ newspaper.filename }}</span>
      </h5>

      <blockquote>{{ newspaper.text }}</blockquote>
    </b-card-body>
  </b-card>
</template>
